import fetch from 'isomorphic-unfetch'

import { RestLink } from 'apollo-link-rest'
import {
  ApolloClient,
  ApolloLink,
  InMemoryCache /* ApolloLink, from */
} from '@apollo/client'
import { apiGeeDomain, API_CONST, ROUTINGKEY } from '../../config/connections'

let { AccessToken = '', routingKey = '' } =
  (typeof sessionStorage !== 'undefined' && sessionStorage) || {}
// Create a RestLink for the REST API
const restLink = new RestLink({
  // uri: GlobalConstants.url().baseUrl,
  uri: `${apiGeeDomain}${API_CONST.rest.query}`,
  // headers: {
  //   Authorization: `Bearer ${AccessToken}`,
  //   routingKey: routingKey || ''
  // },
  customFetch: fetch
})

const authRestLink = new ApolloLink((operation, forward) => {
  operation.setContext(({ headers }) => {
    if (typeof sessionStorage !== 'undefined') {
      AccessToken = sessionStorage.getItem('AccessToken') || ''
      routingKey = sessionStorage.getItem('routingKey') || ''
    }
    return {
      headers: {
        ...(headers || {}),
        Accept: 'application/json',
        Authorization: `Bearer ${AccessToken}`,
        RoutingKey: routingKey || ROUTINGKEY
      }
    }
  })
  return forward(operation)
})

// Configure the ApolloClient with the default cache and RestLink
const restClient = new ApolloClient({
  link: ApolloLink?.from?.([authRestLink, restLink]),
  cache: new InMemoryCache()
})

export default restClient
